import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [
  {
    title: 'Reportes',
    path: '/reportes/envios',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];

const ReporteEnviosPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Envíos</PageTitle>
      <View />
    </>
  );
};

export { ReporteEnviosPage };
